// Application-wide constants

export const MASTER_PASSWORD = 'admin';

// Bank account information for payments
export const BANK_ACCOUNT = {
  bankName: 'Al Rajhi Bank',
  accountNumber: '123456789012345',
  accountHolder: 'Ithraa Al Khair',
  iban: 'SA0380000000123456789012'
};

// Country code to name mapping
export const COUNTRY_CODES = {
  'CH': 'Switzerland',
  'FR': 'France',
  'IT': 'Italy',
  'CA': 'Canada',
  'ES': 'Spain',
  'CN': 'China',
  'GB': 'UK',
  'NL': 'Netherlands',
  'BE': 'Belgium',
  'US': 'USA',
  'DE': 'Germany',
  'SE': 'Sweden',
    'NZ': 'New Zealand'

};